import React, { useState, useEffect } from "react";
import "./headerLogoIcons.css";
import IconNotifi from "../iconNotifi/iconNotifi";
import NavbarDawn from "../NavbarDawn/NavbarDawn";
import logo from "../../assets/logo/logo2.png";
import Menu from "../Menu/Menu";
import { Link } from "react-router-dom"

const HeaderLogoIcon = () => {
	const [isMenuVisible, setIsMenuVisible] = useState(false);

	useEffect(() => {
		const mediaQuery = window.matchMedia(
			"(min-width: 0px) and (max-width: 780px)"
		);
		setIsMenuVisible(mediaQuery.matches);
		const handler = (event) => setIsMenuVisible(event.matches);
		mediaQuery.addEventListener("change", handler);
		return () => mediaQuery.removeEventListener("change", handler);
	}, []);

	return (
		<div className='max-width-lealtad'>
			<div className='nav-img-icon-dawn-lealtad'>
				<div className='icon-box-lealtad'>
					<Link to="/inicio-lealtad">
						<img className='logo-lealtad' src={logo} alt='logo' />
					</Link>
				</div>
				<div className='flex-icon-menu-lealtad'>
					<IconNotifi />
					<NavbarDawn />
					{isMenuVisible && <Menu />}
				</div>
			</div>
		</div>
	);
};

export default HeaderLogoIcon;